import chatModule from '../chatModule';

function detailsController($scope, $log, chatUtility) {
  'ngInject';

  const initator = $scope.dialogData.initiator;
  const currentUserId = $scope.chatLibrary.userId;
  $scope.canConversationRemoveMember = function () {
    if ($scope.dialogData.dialogType !== $scope.dialogType.CHAT) {
      return initator && initator.id === currentUserId && !$scope.dialogData.isUserPending;
    }
    return false;
  };

  $scope.shouldShowAddUser = function () {
    return (
      !$scope.dialogData.isUserPending && chatUtility.getIsGroupChatEnabled($scope.chatLibrary)
    );
  };
}

chatModule.controller('detailsController', detailsController);

export default detailsController;
